module.exports = __webpack_public_path__ + "static/media/fill_60@3x.4344f2be.png";